(function () {
  'use strict';

  if (window.BusinessPopupInit) {
    return;
  }

  window.BusinessPopupInit = function () {

    const popup = document.getElementById('businessQuotePopup');

    if (!popup) return;

    const overlay = popup.querySelector('.business-popup__overlay');
    const closeButton = popup.querySelector('.business-popup__close');
    const popupWrapper = popup.querySelector('.business-popup__wrapper');

    const delay =
      parseInt(popup.dataset.delay || 5, 10) * 1000;

    const hideDays =
      parseInt(popup.dataset.hideDays || 7, 10);

    const storageKey = 'scd_business_popup_hidden_until';

    const autoCloseDelay = parseInt(popup.dataset.autoClose || 10, 10) * 1000;
    let autoCloseTimer = null;

    function isHidden() {
      const value = localStorage.getItem(storageKey);

      if (!value) return false;

      return Date.now() < Number(value);
    }

    function hideForDays() {

      const expires =
        Date.now() + (hideDays * 24 * 60 * 60 * 1000);

      localStorage.setItem(storageKey, expires);

    }

    function openPopup() {

      popup.classList.add('is-visible');

      popup.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'business-popup-open'
      );

      clearTimeout(autoCloseTimer);

      autoCloseTimer = setTimeout(function () {
        closePopup(true);
      }, autoCloseDelay);

    }

    function closePopup(save = true) {

      clearTimeout(autoCloseTimer);

      popup.classList.remove('is-visible');

      popup.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'business-popup-open'
      );

      if (save) {
        hideForDays();
      }

    }

    if (!isHidden()) {

      window.setTimeout(function () {

        openPopup();

      }, delay);

    }

    closeButton.addEventListener(
      'click',
      function () {

        closePopup(true);

      }
    );

    overlay.addEventListener(
      'click',
      function () {

        closePopup(true);

      }
    );

    document.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Escape') {
          closePopup(true);
        }

      }
    );

    popup.addEventListener(
      'click',
      function (event) {

        if (event.target === popup) {
          closePopup(true);
        }

      }
    );

    window.addEventListener(
      'pageshow',
      function () {

        if (popup.classList.contains('is-visible')) {
          popup.setAttribute('aria-hidden', 'false');
        }

      }
    );

    /* Pause auto-close while hovering */

    if (popupWrapper) {

      popupWrapper.addEventListener(
        'mouseenter',
        function () {

          clearTimeout(autoCloseTimer);

        }
      );

      popupWrapper.addEventListener(
        'mouseleave',
        function () {

          clearTimeout(autoCloseTimer);

          autoCloseTimer = setTimeout(function () {

            closePopup(true);

          }, autoCloseDelay);

        }
      );

    }

  };

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      window.BusinessPopupInit
    );

  } else {

    window.BusinessPopupInit();

  }

})();